import styled from 'styled-components'
import Section, { SectionContainer, SectionHeader } from '../common/Section'

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.spacing.xl};
  margin-top: ${({ theme }) => theme.spacing['3xl']};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.lg};
  }
`

const FeatureCard = styled.div`
  background: ${({ theme }) => theme.colors.backgroundLight};
  border: 1px solid ${({ theme }) => theme.colors.backgroundLighter};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing.xl};
  transition: all ${({ theme }) => theme.transitions.base};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${({ theme }) => theme.colors.gradient};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform ${({ theme }) => theme.transitions.base};
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: ${({ theme }) => theme.shadows.xl};
    border-color: ${({ theme }) => theme.colors.primary};

    &::before {
      transform: scaleX(1);
    }
  }
`

const FeatureIcon = styled.div`
  width: 60px;
  height: 60px;
  background: ${({ theme }) => theme.colors.gradientPrimary};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  font-size: 28px;
`

const FeatureTitle = styled.h3`
  font-size: ${({ theme }) => theme.fonts.sizes.xl};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`

const FeatureDescription = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.7;
  margin: 0;
`

const features = [
  {
    id: 1,
    icon: '🎮',
    title: 'Incredible Gameplay',
    description:
      'Experience deep, engaging gameplay with mechanics that push the boundaries of the genre.',
  },
  {
    id: 2,
    icon: '🌐',
    title: 'Vast Open World',
    description:
      'Explore a massive, interconnected world filled with secrets, challenges, and discoveries.',
  },
  {
    id: 3,
    icon: '⚔️',
    title: 'Epic Combat',
    description:
      'Master a dynamic combat system with countless weapons, abilities, and tactical options.',
  },
  {
    id: 4,
    icon: '🎭',
    title: 'Rich Storytelling',
    description:
      'Immerse yourself in a compelling narrative with memorable characters and meaningful choices.',
  },
  {
    id: 5,
    icon: '👥',
    title: 'Multiplayer Mode',
    description:
      'Join forces with friends or compete against players worldwide in various multiplayer modes.',
  },
  {
    id: 6,
    icon: '🎨',
    title: 'Stunning Visuals',
    description:
      'Enjoy breathtaking graphics and art direction that bring the world to life like never before.',
  },
]

const Features = () => {
  return (
    <Section id="features" className="with-background">
      <SectionContainer>
        <SectionHeader>
          <h2>Game Features</h2>
          <p>
            Discover what makes Nexus Realms a revolutionary gaming experience
          </p>
        </SectionHeader>

        <FeaturesGrid>
          {features.map((feature) => (
            <FeatureCard key={feature.id}>
              <FeatureIcon>{feature.icon}</FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </SectionContainer>
    </Section>
  )
}

export default Features
